import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '../ui';

const faqs = [
  { q: 'Comment démarrer avec AccountInTime ?', a: 'Créez un compte gratuit, configurez votre cabinet et commencez à facturer en quelques minutes. Un guide pas-à-pas vous accompagne.' },
  { q: 'La solution est-elle conforme à la Loi de Finances 2026 ?', a: 'Oui, notre plateforme est certifiée et conforme aux dernières exigences DGII, incluant la facturation électronique, la signature XAdES et le fichier TEJ.' },
  { q: 'Puis-je importer mes données existantes ?', a: 'Absolument. Nous supportons l\'import CSV/Excel de vos clients, fournisseurs, factures et écritures comptables.' },
  { q: 'Quel niveau de support est inclus ?', a: 'Tous les plans incluent le support email. Le plan Pro ajoute le support prioritaire, et Enterprise un account manager dédié avec SLA.' },
  { q: 'Mes données sont-elles sécurisées ?', a: 'Oui, hébergement sécurisé, chiffrement AES-256, backups quotidiens et conformité RGPD. Nous avons 0 incident de sécurité à ce jour.' },
];

export default function FaqSection() {
  const [open, setOpen] = React.useState(null);

  return (
    <section id="faq" className="mb-32 max-w-3xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <h2 className="text-4xl font-bold text-white mb-4">Questions fréquentes</h2>
        <p className="text-slate-400 text-lg">Tout ce que vous devez savoir</p>
      </motion.div>

      <div className="space-y-3">
        {faqs.map((faq, i) => (
          <div key={i} className="bg-slate-900/40 backdrop-blur-xl border border-slate-700/50 rounded-2xl overflow-hidden">
            <button
              onClick={() => setOpen(open === i ? null : i)}
              className="w-full flex justify-between items-center p-6 text-left text-white font-medium hover:bg-slate-800/30 transition-colors"
            >
              <span>{faq.q}</span>
              <Icon
                name="IconChevronDown"
                size={20}
                className={`text-slate-400 transition-transform duration-300 ${open === i ? 'rotate-180' : ''}`}
              />
            </button>
            <AnimatePresence>
              {open === i && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <p className="px-6 pb-6 text-slate-400 leading-relaxed">{faq.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </section>
  );
}
